import { APP_KEY_IDS } from "../../constants/constants";
import BaseAppContainer from "../base--app-container/BaseAppContainer";
import BaseNativeAppBar from "../base-native-app-bar/BaseNativeAppBar";
import BaseNativeAppContainer from "../base-native-app-container/BaseNativeAppContainer";
import Styles from "./Safari.module.scss";
import { ReactComponent as StarIcon } from "../../icons/extra_icons/star.svg"

const Safari = () => {

    const menuOptions = [
        {
            id: 0,
            label: "Apple",
            link: "https://www.apple.com/"
        },
        {
            id: 1,
            label: "iCloud",
            link: "https://www.icloud.com/"
        },
        {
            id: 2,
            label: "Google",
            link: "https://www.google.com/"
        },
        {
            id: 3,
            label: "Bing",
            link: "https://www.bing.com/"
        },
        {
            id: 4,
            label: "Wikipedia",
            link: "https://www.wikipedia.org/"
        },
        {
            id: 5,
            label: "Facebook",
            link: "https://www.facebook.com/"
        },
        {
            id: 6,
            label: "Twitter",
            link: "https://twitter.com/"
        },
        {
            id: 7,
            label: "LinkedIn",
            link: "https://www.linkedin.com/"
        },
        {
            id: 8,
            label: "BBC",
            link: "https://www.bbc.com/"
        },
        {
            id: 9,
            label: "Github",
            link: "https://github.com/"
        },
        {
            id: 10,
            label: "priyanshdatyalclicks",
            link: "https://priyanshdatyalclicks.web.app/"
        },

    ]

    return (
        <BaseNativeAppContainer
            loadFromX={50}
            appId={APP_KEY_IDS.SAFARI}
            height={625}
            title={""}
            showHeader={true}
            MainScreen={

                <div className={Styles.browser_container}>

                    <div className={Styles.tab_options_container}>
                        <div className={Styles.tab_options}>
                            {
                                menuOptions.map((option: any) => {
                                    return (
                                        <a className={Styles.option} href={option.link} target="_blank">
                                            {option.label}
                                        </a>
                                    )
                                })
                            }
                        </div>
                        <div className={Styles.star_page_container}>
                            <StarIcon />
                            Star
                        </div>
                    </div>
                    <div className={Styles.frame_container}>        
                        <iframe className={Styles.frame} name="brow" src="./browserbase.html"  ></iframe>
                    </div>
                </div>
            }

        />
    )
}

export default Safari
